import apiFetch from '../apiFetch'

export default function (idLinea, token) {
  return apiFetch({endPoint: `LineaGenetica/getLineaGeneticaCambioEstado`, method: 'POST', body: {idLinea}, token: token})
}
